import {
  BodyLG,
  BodyLGB,
  BodyMDB,
  BodyXL,
  Heading2XL,
  Heading5XL,
} from "../../../typography";

import { Link } from "react-router-dom";
import { RiveAnimation } from "../../components/ui/RiveAnimation";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";

export const Hero = () => (
  <div className="tw-relative tw-flex tw-items-center tw-gap-y-[32px]">
    <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-x-[3.5em] tw-gap-y-[42px] min440:tw-flex-row min440:tw-px-[24px]">
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-y-[1.5em] tw-text-center min440:tw-w-1/2 min440:tw-items-start min440:tw-text-left">
        <Heading2XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min1040:tw-flex">
          Verse Medical
        </Heading2XL>
        <BodyXL className="tw-my-0 tw-w-full tw-text-white min1040:tw-hidden">
          Verse Medical
        </BodyXL>
        <Heading5XL className="tw-my-0 tw-hidden tw-w-full tw-text-white min1040:tw-flex">
          Make amazing in-home healthcare possible.
        </Heading5XL>
        <Heading2XL className="tw-my-0 tw-w-full tw-text-white min1040:tw-hidden">
          Make amazing in-home healthcare possible.
        </Heading2XL>

        <BodyXL className="tw-my-0 tw-hidden tw-w-full tw-text-white min1040:tw-flex">
          Verse Medical was founded in 2018 to build the infrastructure for
          in-home healthcare, starting with equipment & supplies.
        </BodyXL>
        <BodyLG className="tw-my-0 tw-w-full tw-text-white min1040:tw-hidden">
          Verse Medical was founded in 2018 to build the infrastructure for
          in-home healthcare, starting with equipment & supplies.
        </BodyLG>

        <StandardButton
          onClick={() => {}}
          style={"primary-blue"}
          className="tw-w-[13.75em] tw-rounded-full tw-px-[2em] tw-py-[1em] tw-text-[16px]"
        >
          <Link to="/contact" className="tw-no-underline">
            <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
              Get a demo
            </BodyLGB>
            <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
              Get a demo
            </BodyMDB>
          </Link>
        </StandardButton>
      </div>
      <div className="tw-flex tw-max-h-[600px] tw-w-full tw-max-w-[550px] min440:tw-w-1/2">
        <RiveAnimation
          fallbackSrc="/landing_page_assets/about/About1.png"
          fallbackClassName="tw-h-full tw-w-full tw-rounded-[2em]"
        />
      </div>
    </div>
  </div>
);
